import {ReactNode} from 'react';

import {view} from '@sail/ui';

import {AssistantContainer} from '@stripe-internal/conversations-assistant';

export function MobileAssistantContainer({children}: {children: ReactNode}) {
  return (
    <view.div css={{height: '100vh'}}>
      <AssistantContainer>{children}</AssistantContainer>
    </view.div>
  );
}
